import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Form,
  Table,
  Avatar,
} from "antd";
import IntlMessages from "../../../util/IntlMessages";
import ds from "../../../Services/DataServices";
import { useHistory } from "react-router-dom";
import { useDispatch, useStore, useSelector } from "react-redux";
import { formatDigits } from "../../../appRedux/actions";

const ExpandView = (props) => {
  const { recPay, getCurrSymbol } = props;
  const history = useHistory();
  const store = useStore();
  const [form] = Form.useForm();
  const dispatch = useDispatch();

  const getReduxClosedRegData = useSelector(
    ({ Sell }) => Sell.opencloseRegClosedData
  );
  const getDecimalPlaces = useSelector(
    ({ MainSale }) => MainSale.getDefaultDecimalPlaces
  );
  
  function evenOrOdd(num) {
    //for string length take string
    if (num % 2 == 0) {
      //and replace numm with string.length here
      return "even";
    } else {
      return "odd";
    }
  }

  const columnsCash = [
    {
      title: <IntlMessages id="sell.openclose.cashcol1" />,
      dataIndex: "time",
      key: "time",
      render: (text, record) => {
        let date = "";
        if (record.time) {
          if (record.time.includes("T")) {
            date = record.time.split("T")[1];
          }
        }
        return (
          <div>
             <h5 className="gx-link"> {record.date} </h5>
                <p>{date}</p>
          </div>
        );
      },
    },
    {
      title: <IntlMessages id="sell.openclose.cashcol2" />,
      dataIndex: "user",
      key: "user",
      render: (text, record, key) => {
        let isEvenOrOdd = evenOrOdd(key);
        return (
          <>
            <div className="gx-module-list-icon">
              <Row>
                {/* <Col>
                  <div className="gx">
                    <Avatar
                      style={{ fontWeight: "bold" }}
                      className={`gx-avatar gx-bg-${isEvenOrOdd == "even" ? "green" : "blue"
                        } gx-size-46 mr-10`}
                    >
                      {record.nameLetter}
                    </Avatar>
                  </div>
                </Col> */}

                <Col style={{ marginLeft: 12 }}>
                  <div className="gx-module-list-content">
                    <div className="gx-mail-user-des">
                      <span className="gx-sender-name">{text}</span>

                      <span className="gx-toolbar-separator">&nbsp;</span>

                      <p className="vd-flag sm:hidden">{record.role}</p>
                    </div>
                    <div className="gx-message">
                      <p className="gx-text-truncate"> {record.email}</p>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </>
        );
      },
    },
    {
      title: <IntlMessages id="sell.openclose.cashcol3" />,
      dataIndex: "amount",
      key: "amount",
      render: (text, record) => {
        let isOut = false;
        if (record.reason == "CO" || record.reason == "PCO") {
          isOut = true;
        }
        return (
          <h5
            className="gx-link"
            style={{
              fontWeight: "500",
              color: isOut ? "rgb(215, 113, 115)" : "#41af4b",
            }}
          >
            {isOut ? "-" : ""}
            {text ? formatDigits(text, getDecimalPlaces) : "0.00"}
            {getCurrSymbol}
          </h5>
        );
      },
    },
    {
      title: <IntlMessages id="sell.openclose.cashcol4" />,
      key: "reason",
      dataIndex: "reason",
      render: (text, record) => {
        return (
          <div>
            <Row>
              <Col>
                <h5>
                  {record.reason == "OF" ? (
                    <>
                      <IntlMessages id="sell.cashlisting.openingfloat" />
                    </>
                  ) : record.reason == "CI" ? (
                    <>
                      <IntlMessages id="sell.cashlisting.cashin" />
                    </>
                  ) : record.reason == "CO" ? (
                    <>
                      <IntlMessages id="sell.cashlisting.cashout" />
                    </>
                  ) : record.reason == "PCI" ? (
                    <>
                      <IntlMessages id="sell.cashlisting.pettycashin" />
                    </>
                  ) : record.reason == "PCO" ? (
                    <>
                      <IntlMessages id="sell.cashlisting.pettycashout" />
                    </>
                  ) : (
                    <></>
                  )}
                </h5>
              </Col>
            </Row>
            <Row>
              <Col>
                <h6 style={{ fontWeight: "500", color: "#038fde" }}>
                  {record.note}
                </h6>
              </Col>
            </Row>
          </div>
        );
      },
    },
  ];

  return (
    <div className="gx-main-content-wrapper" style={{ marginTop: -22 }}>
      <Row gutter={20}>
        <Col>
          <strong style={{ color: "#6692b0" }}>
            <IntlMessages id="sell.openclose.cashmove" />
          </strong>
        </Col>

        <Col>
          <div style={{ width: "100%" }}>
            <Table
              className="gx-table-responsive expanded-cashmove"
              columns={columnsCash}
              dataSource={
                getReduxClosedRegData &&
                  getReduxClosedRegData.registerInOut &&
                  getReduxClosedRegData.registerInOut.length > 0
                  ? getReduxClosedRegData.registerInOut
                  : []
              }
              // loading={
              //   getReduxClosedRegData &&
              //   getReduxClosedRegData.registerInOut &&
              //   getReduxClosedRegData.registerInOut.length > 0
              //     ? false
              //     : true
              // }
              pagination={false}
            // onChange={handleTableChange}
            />
          </div>
        </Col>
      </Row>

      <Row style={{ marginTop: 22 }} gutter={46}>
        <Col>
          <strong style={{ color: "#6692b0" }}>
            <IntlMessages id="sell.openclose.cashrec" />
          </strong>
        </Col>

        <Col>
          <strong>
            {recPay ? formatDigits(recPay, getDecimalPlaces) : "0.00"}
            {getCurrSymbol}
          </strong>
        </Col>
      </Row>
    </div>
  );
};

export default ExpandView;
